import { ctabg } from "../Assets";
import { motion } from "framer-motion";

const CTA = () => {
  return (
    <section
      className="w-full px-4 sm:px-6 md:px-8 py-36 sm:py-24 md:py-48 lg:py-64 text-center text-white relative overflow-hidden "
      style={{
        backgroundImage: `url(${ctabg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <motion.div
        className="max-w-3xl mx-auto space-y-6 relative z-10"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      >
        <motion.h2
          className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          Say goodbye to waiting and hello to{" "}
          <span style={{ color: "#F458FF" }}>instant execution</span>
        </motion.h2>

        <motion.p
          className="text-sm sm:text-base md:text-lg text-gray-300"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          NTB is the fastest and most fearless way to trade on Monad, powered by
          Monadscore, the DeFi intelligence suite redefining speed and safety.
          Buy, sell, and track tokens directly on Telegram, all in seconds, all
          on-chain.
        </motion.p>

        <a href="https://t.me/nadstradebot" target="_blank" rel="noopener noreferrer">
          <motion.button
            className="mt-6 px-8 py-3 rounded-lg font-semibold text-white"
            style={{ backgroundColor: "#F458FF" }}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            Launch Nads Trading Bot
          </motion.button>
        </a>
      </motion.div>
    </section>
  );
};

export default CTA;